module.exports = __webpack_public_path__ + "img/03.07962db2.png";